import React from 'react';
import MainButton from '../../shared/layout/buttons/MainButton';
import { sendFrontendLog } from '../../services/ClientLogger';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: '' };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            errorMessage: error?.message || 'Unexpected application error.'
        };
    }

    componentDidCatch(error, errorInfo) {
        // Keep console logging for debugging while showing user-safe fallback UI.
        // eslint-disable-next-line no-console
        console.error('AppErrorBoundary caught an error:', error, errorInfo);
        sendFrontendLog({
            severity: 'error',
            eventType: 'react_error_boundary',
            message: error?.message || 'React error boundary caught an error',
            errorType: error?.name || 'react_error',
            stackTrace: error?.stack || null,
            metadata: {
                component_stack: errorInfo?.componentStack || null,
            },
        });
    }

    handleReload() {
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1.5rem',
                    background: '#f8fafc'
                }}>
                    <div style={{
                        maxWidth: '35rem',
                        width: '100%',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '0.75rem',
                        padding: '1.5rem',
                        boxShadow: '0 0.5rem 1.25rem rgba(0,0,0,0.06)'
                    }}>
                        <h2 style={{ marginTop: 0, marginBottom: '0.5rem', color: '#111827' }}>
                            Something went wrong
                        </h2>
                        <p style={{ marginTop: 0, marginBottom: '1rem', color: '#4b5563' }}>
                            The application hit an unexpected error. Please reload the page.
                        </p>
                        <p style={{ marginTop: 0, marginBottom: '1.25rem', color: '#6b7280', fontSize: '0.9rem' }}>
                            {this.state.errorMessage}
                        </p>
                        <MainButton onClick={() => this.handleReload()}>Reload</MainButton>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
